import { format } from "date-fns";

import { formatCurrency } from "@/lib/formatters";

import type { BudgetReviewItem } from "@/schemas";

export function ReviewCandidateCard({
  title,
  candidate,
  currencyCode,
}: {
  title: string;
  candidate: BudgetReviewItem["auto_candidate"];
  currencyCode: string;
}) {
  return (
    <div className="rounded-md bg-muted/50 p-3">
      <p className="text-xs font-semibold uppercase text-muted-foreground">
        {title}
      </p>
      <div className="mt-1 flex items-baseline justify-between">
        <p className="text-sm font-medium">
          {candidate.description || "No description"}
        </p>
        <p className="font-medium">
          {formatCurrency(candidate.amount, currencyCode)}
        </p>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">
        {format(new Date(candidate.record_date), "MMM d, yyyy")}
      </p>
    </div>
  );
}
